import { LabelValue } from '~/components/component-library/LabelValue'
import { PropertyRow } from '~/components/txn-display/properties/PropertyRow'

type TransactionPropertiesProps = {
  properties?: Record<string, unknown> | null
}

export const TransactionProperties = ({
  properties,
}: TransactionPropertiesProps) => {
  // Hide section entirely when empty — no placeholder copy
  // (Stripe / Vercel / AWS metadata convention).
  if (!properties) return null
  const entries = Object.entries(properties)
  if (entries.length === 0) return null

  const fieldsLabel = `${entries.length} field${entries.length === 1 ? '' : 's'}`

  return (
    <LabelValue
      label="Properties"
      value={fieldsLabel}
      isCollapsible
      size="small"
      defaultOpen
    >
      <div className="flex flex-col">
        {entries.map(([key, value], index) => (
          <PropertyRow key={key} label={key} value={value} listIndex={index} />
        ))}
      </div>
    </LabelValue>
  )
}
